if (!customElements.get('card-compact-quick-add')) {
  customElements.define(
    'card-compact-quick-add',
    class CardCompactQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('.compact-quick-add__toggle');
        this.sizesPanel = this.querySelector('.compact-quick-add__sizes');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.toggle.addEventListener('click', this.onToggleClick.bind(this));

        if (this.sizesPanel) {
          this.querySelectorAll('.compact-quick-add__size').forEach((button) => {
            button.addEventListener('click', this.onSizeClick.bind(this));
          });
          this.boundOnDocumentClick = this.onDocumentClick.bind(this);
          document.addEventListener('click', this.boundOnDocumentClick);
        }
      }

      disconnectedCallback() {
        if (this.boundOnDocumentClick) {
          document.removeEventListener('click', this.boundOnDocumentClick);
        }
      }

      onToggleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.toggle.getAttribute('aria-disabled') === 'true') return;

        if (this.sizesPanel) {
          this.closeSiblingPanels();
          this.classList.toggle('is-open');
          return;
        }

        this.addToCart(this.dataset.variantId);
      }

      onSizeClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.currentTarget.disabled) return;
        this.addToCart(event.currentTarget.dataset.variantId);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) {
          this.classList.remove('is-open');
        }
      }

      closeSiblingPanels() {
        document.querySelectorAll('card-compact-quick-add.is-open').forEach((element) => {
          if (element !== this) element.classList.remove('is-open');
        });
      }

      addToCart(variantId) {
        if (!variantId || this.classList.contains('is-loading')) return;

        this.classList.add('is-loading');
        this.classList.remove('is-open');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'card-compact-quick-add',
              productVariantId: variantId,
              cartData: response,
            });

            if (typeof window.upcartOpenCart === 'function') {
              // UpCart owns the drawer and focus lock; do not open Dawn's drawer too.
              if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
              window.upcartOpenCart();
            } else if (this.cart) {
              this.cart.renderContents(response);
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.watchForDrawerClose();
            }

            this.classList.add('is-added');
            clearTimeout(this.addedTimeout);
            this.addedTimeout = setTimeout(() => this.classList.remove('is-added'), 1800);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.classList.remove('is-loading');
          });
      }

      // Some cart apps (e.g. Upcart) hook fetch('/cart/add') to add their own
      // scroll-lock classes to <body>, but never actually open a working popup
      // of their own here, so closing this theme's drawer leaves the page
      // unscrollable. Once our drawer closes, clear any such leftover locks.
      watchForDrawerClose() {
        if (!this.cart || !this.cart.classList || this.drawerObserver) return;

        this.drawerObserver = new MutationObserver(() => {
          if (!this.cart.classList.contains('active')) {
            this.drawerObserver.disconnect();
            this.drawerObserver = null;
            requestAnimationFrame(() => {
              if (document.querySelector('cart-drawer.active, cart-notification.active')) return;
              document.body.classList.remove('upcartPopupShow', 'fw-lock-scroll');
              document.documentElement.style.overflow = '';
              document.body.style.overflow = '';
            });
          }
        });
        this.drawerObserver.observe(this.cart, { attributes: true, attributeFilter: ['class'] });
      }
    }
  );
}
